import React from 'react';
import { grey } from '@mui/material/colors';
import { AcUnit } from '@mui/icons-material';
import { IconButton, Stack, Typography, Divider } from '@mui/material';

import { WorkInProgressView } from '../WorkInProgressView';

export const MonthPanel = () => {
  return (
    <Stack border={`1px solid ${grey[200]}`} boxShadow={1} borderRadius="0.5rem" padding="1rem" gap="1rem">
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography>My Calendars</Typography>

          <IconButton disabled size="small" color="primary" className="icon-btn-bordered" onClick={() => {}}>
            <AcUnit fontSize="small" />
          </IconButton>
        </Stack>

        <WorkInProgressView />
      </Stack>

      <Divider sx={{ borderColor: grey[200] }} />

      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography>Other Calendars</Typography>

          <IconButton disabled size="small" color="primary" className="icon-btn-bordered" onClick={() => {}}>
            <AcUnit fontSize="small" />
          </IconButton>
        </Stack>

        <WorkInProgressView />
      </Stack>
    </Stack>
  );
};
